import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function replace (location) {
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: {
            title: '首页',
        },
    },
    // {
    //     path: '/baseForm',
    //     name: 'baseForm',
    //     component: () => import('../views/baseForm/index.vue'),
    //     meta: {
    //         title: '表单示例',
    //     },
    // },
    {
        path: '/goDraw',
        name: 'goDraw',
        component: () => import('../views/goDraw/index.vue'),
        meta: {
            title: '去抽奖',
        },
    },
    {
        path: '/draw',
        name: 'draw',
        component: () => import('../views/draw/index.vue'),
        meta: {
            title: '抽奖',
        },
    },
    {
        path: '/record',
        name: 'record',
        component: () => import('../views/record/index.vue'),
        meta: {
            title: '获奖记录',
        },
    },
    {
        path: '/watchAdver',
        name: 'watchAdver',
        component: () => import('../views/watchAdver/index.vue'),
        meta: {
            title: '看健康科普',
        },
    },
    {
        path: '/answer',
        name: 'answer',
        component: () => import('../views/answer/index.vue'),
        meta: {
            title: '答题',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index.vue'),
        meta: {
            title: '登录',
        },
    },
]

const router = new VueRouter({
    routes,
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    let token = sessionStorage.getItem('token')
    if (process.env.NODE_ENV === 'development') {
        next()
    } else {
        if (!token && to.path !== '/login') {
            sessionStorage.setItem('path', to.fullPath)
            router.replace({ path: '/login', query: { redirect: to.fullPath } })
        } else if (token && to.path === '/login') {
            router.push({ name: 'home' })
        } else {
            next()
        }
    }
    // if (!token && to.path !== '/login') {
    //     sessionStorage.setItem('path', to.fullPath)
    //     router.replace({ path: '/login', query: { redirect: to.fullPath } })
    // } else if (token && to.path === '/login') {
    //     // location.href = `${location.protocol}//${location.host}/#/index`
    //     router.replace('/')
    // } else {
    //     next()
    // }

})

export default router
